import React from "react"
import ImageMarker from "./ImageMarker"
import IconMarker from "./IconMarker"
import type { MarkerLayerProps, Place, Category } from "../../../types"
import "../styles/Markers.scss"

const MarkerLayer: React.FC<MarkerLayerProps> = ({ places, selectedPlace, onMarkerClick, onMarkerHover, onMarkerLeave }) => {
  const getCategoryName = (categories: Category[] | undefined): string => {
    if (!categories || categories.length === 0) return "default"
    return categories[0].name.toLowerCase()
  }

  const getPlaceImage = (properties: any): string | undefined => {
    return (
      properties.image ||
      properties.thumbnail_url ||
      (properties.vibemap_images && properties.vibemap_images[0]?.thumbnail_url) ||
      (properties.vibemap_images && typeof properties.vibemap_images[0] === "string" && properties.vibemap_images[0])
    )
  }

  return (
    <>
      {places.map((place: Place) => {
        if (!place.geometry?.coordinates) return null

        const [longitude, latitude] = place.geometry.coordinates
        const isSelected = selectedPlace?.id === place.id
        const image = getPlaceImage(place.properties)
        const markerType = place.properties.markerType

        if (markerType === "image" && image) {
          return (
            <ImageMarker
              key={place.id}
              latitude={latitude}
              longitude={longitude}
              image={image}
              isSelected={isSelected}
              onClick={() => onMarkerClick(place)}
              onMouseEnter={() => onMarkerHover?.(place)}
              onMouseLeave={() => onMarkerLeave?.(place)}
            />
          )
        } else {
          return (
            <IconMarker
              key={place.id}
              latitude={latitude}
              longitude={longitude}
              category={getCategoryName(place.properties.categories)}
              isSelected={isSelected}
              onClick={() => onMarkerClick(place)}
              onMouseEnter={() => onMarkerHover?.(place)}
              onMouseLeave={() => onMarkerLeave?.(place)}
            />
          )
        }
      })}
    </>
  )
}

export default MarkerLayer
